import { action, decorate, observable } from 'mobx';

class PopupStore {

  constructor() {
    window.popup = this;
  }

  popupData = {
    show: false,
    loading: false,
  };

  popupMandato = {
    show: false,
  };

  popupAutorizacionDatosPersonales = {
    show: false,
  };

  popupAutorizacionPrevired = {
    show: false,
  };

  showPopup() {
    let data = this.popupData;
    data.show = true;
    this.popupData = data;
  }

  hidePopup() {
    let data = this.popupData;
    data.show = false;
    this.popupData = data;
  }

  setPopupData(data) {
    data.show = false;
    data.loading = false;
    this.popupData = data;
  }

  showPopUpMandato = () => {
    this.popupMandato.show = true;
  };

  hidePopupMandato = () => {
    this.popupMandato.show = false;
  };

  hidePopupAutorizacionDatosPersonales = () => {
    this.popupAutorizacionDatosPersonales.show = false;
  };

  showPopupAutorizacionDatosPersonales = () => {
    this.popupAutorizacionDatosPersonales.show = true;
  };

  hidePopupAutorizacionPrevired = () => {
    this.popupAutorizacionPrevired.show = false;
  };

  showPopupAutorizacionPrevired = () => {
    this.popupAutorizacionPrevired.show = true;
  };
}

decorate(PopupStore, {
  popupData: observable,
  showPopup: action,
  hidePopup: action,
  setPopupData: action,
  popupMandato: observable,
  popupAutorizacionDatosPersonales: observable,
  hidePopupMandato: action,
  showPopUpMandato: action,
  hidePopupAutorizacionDatosPersonales: action,
  showPopupAutorizacionDatosPersonales: action,
  popupAutorizacionPrevired: observable,
  showPopupAutorizacionPrevired: action,
  hidePopupAutorizacionPrevired: action,
});

const popup = new PopupStore();
export default popup;